import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { ReactComponent as TheMinds } from "../assets/Minds.svg"; // Import SVG

export default function Minds() {
  return (
    <Box
      sx={{
        padding: 4,
        borderRadius: 2,
        margin: "auto",
        width: {
          xs: "80%", // 90% width on extra-small devices
          sm: "80%", // 80% width on small devices
          lg: "75%", // 60% width on large devices
        },
        mt: {
          lg: 10,
          sm: 10,
          xs: 5,
        },
        mb: {
          lg: 10,
          sm: 10,
          xs: 5,
        },
      }}
    >
      <Stack
        direction="column" // Column layout for image and text
        alignItems="center" // Center align content
        spacing={7} // Space between the image and text
        mb={10} // Add margin to the bottom
      >
        {/* Text Section */}
        <Typography
          fontWeight={"700"}
          fontSize={{
            xs: "24px", // Smaller font size for extra-small devices
            sm: "32px", // Medium font size for small devices
            lg: "48px", // Larger font size for large
          }}
          align="center"
          gutterBottom
          fontFamily={"SF Pro Display"}
        >
          <span style={{ color: "#2361df", fontFamily: "SF Pro Display" }}>
            T
          </span>
          he{" "}
          <span style={{ color: "#2361df", fontFamily: "SF Pro Display" }}>
            M
          </span>
          inds{" "}
          <span style={{ color: "#2361df", fontFamily: "SF Pro Display" }}>
            B
          </span>
          ehind
        </Typography>
        <TheMinds
          style={{
            width: "90%",
            height: "50%",
            objectFit: "cover", // Ensures the SVG fills the entire box
          }}
        />
        <Typography
          fontSize={{
            xs: "16px", // Smaller font size for extra-small devices
            sm: "20px", // Medium font size for small devices
            lg: "24px", // Larger font size for large
          }}
          fontWeight={"300"}
          fontFamily={"SF Pro Display"}
          color="rgba(35, 38, 47, 1)"
          letterSpacing={"0.4px"}
        >
          Our organization is a cohesive ecosystem of skilled professionals and
          researchers, united by a common passion to revolutionize healthcare
          and improve outcomes for millions of patients globally. Our vision is
          of a future where healthcare becomes anticipatory, tailored to each
          individual, and seamlessly woven into their daily existence. Our
          commitment lies in spearheading a groundbreaking era of preventive and
          ongoing monitoring solutions, empowering individuals to assume greater
          control over their health and overall well-being.
        </Typography>
      </Stack>
    </Box>
  );
}
